import { WINDOW } from "../index";
import afterInit from "./Main/listeners/events/after-init";
import beforeMutation from "./utils/initialization/before-mutations";
import setPlatform from "./utils/set-platform";

const script = /** @type {WindowScriptProps} */ (WINDOW.get("script"));
const method = script.torInit || "auto";

/**
 * Automatic TorusKit initialization (default)
 */
const auto = () => {
  if (method !== "auto" && method !== "postpone") {
    return;
  }

  beforeMutation();

  document.addEventListener("DOMContentLoaded", function () {
    requestAnimationFrame(() => {
      /** Add `tor-{user-agent}` classes to the <body> */
      setPlatform();

      if (method !== "postpone") {
        afterInit();
      }
    });
  });
};

export default auto;
